import { useSuspenseQuery } from "@tanstack/react-query";
import api from "apis";
import { AuthorityDto } from "apis/data-contracts";

interface useUserAuthoritiesQueryProps {
  isOriginData?: boolean;
}

const useUserAuthoritiesQuery = ({
  isOriginData = false,
}: useUserAuthoritiesQueryProps | undefined = {}) => {
  return useSuspenseQuery({
    queryKey: api.user.getAuthoritiesKey(),
    queryFn: api.user.getAuthorities,
    select: (authoritiesData) => {
      if (isOriginData) {
        return [
          ...authoritiesData?.data.result.authorities,
          {
            isSuperAdmin: false,
            name: "일반 회원",
            uuid: null,
          },
        ] as AuthorityDto[];
      }

      return [
        ...authoritiesData?.data.result.authorities.filter(
          (authority) => !authority?.isSuperAdmin,
        ),
        {
          isSuperAdmin: false,
          name: "일반 회원",
          uuid: null,
        },
      ] as AuthorityDto[];
    },
  });
};

export default useUserAuthoritiesQuery;
